import { render } from "./RematesSection.vue?vue&type=template&id=8c7747ba&scoped=true&ts=true"
import script from "./RematesSection.vue?vue&type=script&lang=ts"
export * from "./RematesSection.vue?vue&type=script&lang=ts"

import "./RematesSection.vue?vue&type=style&index=0&id=8c7747ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c7747ba"]])

export default __exports__